import { DefaultUrlSerializer, ParamMap, Params, PRIMARY_OUTLET } from '@angular/router';

export type InvoiceHost = 'survey' | 'preview';

export function invoiceHost(value: unknown): InvoiceHost | null {
  return value === 'survey' || value === 'preview' ? value : null;
}

export function queryParamsFromMap(map: ParamMap): Params {
  return map.keys.reduce((params, key) => {
    const values = map.getAll(key);
    params[key] = values.length === 1 ? values[0] : values;
    return params;
  }, {} as Params);
}

// Keep embedding context in the URL so reload/back navigation needs no saved state.
export function invoiceNavigationQueryParams(
  currentUrl: string,
  currentParams: Params,
  sessionKey?: string | null,
): Params {
  const params = { ...currentParams };
  const current = new DefaultUrlSerializer().parse(currentUrl);
  const path = current.root.children[PRIMARY_OUTLET]?.segments[0]?.path;
  const host =
    invoiceHost(path) ??
    (path === 'invoicing'
      ? invoiceHost(params.invoiceHost)
      : null);
  delete params.id;
  delete params.i;

  if (host) {
    params.invoiceHost = host;
  } else {
    delete params.invoiceHost;
  }

  const key = sessionKey?.trim() ||
    (typeof params.k === 'string' ? params.k.trim() : '');
  if (key) {
    params.k = key;
  } else {
    delete params.k;
  }
  return params;
}

export function nonNegativeInteger(value: unknown): number | null {
  if (
    (typeof value !== 'number' && typeof value !== 'string') ||
    (typeof value === 'string' && !value.trim())
  ) {
    return null;
  }
  const number = Number(value);
  return Number.isSafeInteger(number) && number >= 0 ? number : null;
}

export function positiveInteger(value: unknown): number | null {
  const number = nonNegativeInteger(value);
  return number != null && number > 0 ? number : null;
}
